<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/label/rule/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('tiaomaguizebianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('tiaomaguizemingchen')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yewuleixing')">
            <yi_dictionary_select :max="999" clearable="false" :type="'BUSINESS_TYPE'" :ids.sync="yt.conditions.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')">
            <el-select v-model="yt.conditions.isEnabled">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          v-if="utils.checkPower('web_base_label_management_list_create')"
          @click="
            yt.showEditDialog('xinzeng', null, 'w2');
            setDefaultValue();
            getProcedureCode();
          "
          type="primary"
        >
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 自定义某个字段 -->
      <!-- 操作插槽 -->
      <template #guizexiangqing="scope">
        <div style="display:flex">
          <p v-for="(detail, i) in scope.row.labelRuleDetailsVOList"><span v-if="i != 0">+</span>{{ $t(store.state.dictJsonAll['BAR_CODE_RULE_TYPE'][detail.ruleType]) }}</p>
        </div>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button
              type="text"
              v-if="utils.checkPower('web_base_label_management_list_update')"
              @click="
                yt.showEditDialog('bianji', scope.row, 'w2');
                setDefaultValue2(scope.row);
                getProcedureCode();
              "
            >
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" v-if="utils.checkPower('web_base_label_management_list_delete')" @click="yt.remove(scope.row, '/web/label/rule/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('tiaomaguizebianma')" required>
            <el-input v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('tiaomaguizemingchen')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yewuleixing')" required>
            <yi_dictionary_select :max="1" clearable="false" :type="'BUSINESS_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.isEnabled">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
          <p style="font-size: 18px;margin-bottom: 26px;margin-top: 38px">
            {{ $t('guizemingxi') }}
          </p>
          <div style="width: 100%;height:100%">
            <el-button size="mini" type="primary" :disabled="moveButton" @click="move(1)">{{ $t('shangyi') }}</el-button>
            <el-button size="mini" type="primary" :disabled="moveButton" @click="move(2)">{{ $t('xiayi') }}</el-button>
            <el-table ref="singleTable" :data="labelRuleDetailsVOList" highlight-current-row @current-change="handleCurrentChange" style="width: 100%">
              <el-table-column width="50">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.checked"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column width="80">
                <template slot-scope="scope">
                  <el-button @click.native.prevent="deleteRow(scope.$index, labelRuleDetailsVOList)" type="text" size="small">
                    <i class="el-icon-remove-outline"></i>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column type="index" width="80" :label="$t('paixu')"> </el-table-column>
              <el-table-column :label="$t('guizeleixing')" width="300">
                <template slot-scope="scope">
                  <yi_dictionary_select size="mini" :max="1" clearable="false" :type="'BAR_CODE_RULE_TYPE'" :ids.sync="scope.row.ruleType"> </yi_dictionary_select>
                </template>
              </el-table-column>
              <el-table-column prop="initialValue" :label="$t('qishizhi/geshi')">
                <template slot-scope="scope">
                  <el-input-number v-show="scope.row.ruleType == 2" size="mini" min="1" max="10" step-strictly v-model="scope.row.input2"></el-input-number>
                  <el-input-number v-show="scope.row.ruleType == 3" size="mini" min="1" max="10" step-strictly v-model="scope.row.input3"></el-input-number>
                  <el-input v-show="scope.row.ruleType == 4" size="mini" maxlength="10" show-word-limit v-model="scope.row.input4"></el-input>
                  <yi_dictionary_select v-show="scope.row.ruleType == 5" size="mini" :max="1" clearable="false" :type="'TIMES_FORMAT'" :ids.sync="scope.row.input5"> </yi_dictionary_select>
                  <yi_dictionary_select v-show="scope.row.ruleType == 6" size="mini" :max="1" clearable="false" :type="'SEPARATOR'" :ids.sync="scope.row.input6"> </yi_dictionary_select>
                  <el-input-number v-show="scope.row.ruleType == 8" size="mini" min="1" max="10" step-strictly v-model="scope.row.input8"></el-input-number>
                </template>
              </el-table-column>
            </el-table>

            <div style="padding-top: 10px;padding-bottom: 10px;">
              <el-button @click.native.prevent="addRow(labelRuleDetailsVOList)" type="text" size="small">
                <i class="el-icon-circle-plus-outline">{{ $t('zengjiayitiaoguizemingxi') }}</i>
              </el-button>
            </div>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/label/rule/create', beforeNewAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('tiaomaguizebianma')" required>
            <el-input v-model="yt.editObj.code" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('tiaomaguizemingchen')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yewuleixing')" required>
            <yi_dictionary_select :max="1" clearable="false" :type="'BUSINESS_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.isEnabled">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
          <p style="font-size: 18px;margin-bottom: 26px;margin-top: 38px">
            {{ $t('guizemingxi') }}
          </p>
          <div style="width: 100%;height:100%">
            <el-button size="mini" type="primary" :disabled="moveButton" @click="move(1)">{{ $t('shangyi') }}</el-button>
            <el-button size="mini" type="primary" :disabled="moveButton" @click="move(2)">{{ $t('xiayi') }}</el-button>
            <el-table ref="singleTable" :data="labelRuleDetailsVOList" highlight-current-row @current-change="handleCurrentChange" style="width: 100%">
              <el-table-column width="50">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.checked"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column width="80">
                <template slot-scope="scope">
                  <el-button @click.native.prevent="deleteRow(scope.$index, labelRuleDetailsVOList)" type="text" size="small">
                    <i class="el-icon-remove-outline"></i>
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column type="index" width="80" :label="$t('paixu')"> </el-table-column>
              <el-table-column :label="$t('guizeleixing')" width="300">
                <template slot-scope="scope">
                  <yi_dictionary_select size="mini" :max="1" clearable="false" :type="'BAR_CODE_RULE_TYPE'" :ids.sync="scope.row.ruleType"> </yi_dictionary_select>
                </template>
              </el-table-column>
              <el-table-column prop="initialValue" :label="$t('qishizhi/geshi')">
                <template slot-scope="scope">
                  <el-input-number v-show="scope.row.ruleType == 2" size="mini" min="1" max="10" step-strictly v-model="scope.row.input2"></el-input-number>
                  <el-input-number v-show="scope.row.ruleType == 3" size="mini" min="1" max="10" step-strictly v-model="scope.row.input3"></el-input-number>
                  <el-input v-show="scope.row.ruleType == 4" size="mini" maxlength="10" v-model="scope.row.input4"></el-input>
                  <yi_dictionary_select v-show="scope.row.ruleType == 5" size="mini" :max="1" clearable="false" :type="'TIMES_FORMAT'" :ids.sync="scope.row.input5"> </yi_dictionary_select>
                  <yi_dictionary_select v-show="scope.row.ruleType == 6" size="mini" :max="1" clearable="false" :type="'SEPARATOR'" :ids.sync="scope.row.input6"> </yi_dictionary_select>
                  <el-input-number v-show="scope.row.ruleType == 8" size="mini" min="1" max="10" step-strictly v-model="scope.row.input8"></el-input-number>
                </template>
              </el-table-column>
            </el-table>

            <div style="padding-top: 10px;padding-bottom: 10px;">
              <el-button @click.native.prevent="addRow(labelRuleDetailsVOList)" type="text" size="small">
                <i class="el-icon-circle-plus-outline">{{ $t('zengjiayitiaoguizemingxi') }}</i>
              </el-button>
            </div>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/label/rule/update', beforeNewAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 导入excel -->
    <import-excel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
// import importExcel from './import_excel'
export default {
  name: 'web_label_management_label_rule_list',
  components: {
    // importExcel
  },
  data() {
    return {
      moveButton: true,
      currentRow: null,
      value: '',
      labelRuleDetailsVOList: [],
      multipleSelection: [],
      show: false,
      codeAndDesc: '',
      columns: [
        {
          label: 'tiaomaguizebianma',
          prop: 'code',
          width: 180
        },
        {
          label: 'tiaomaguizemingchen',
          prop: 'name',
          width: 180
        },
        {
          label: 'yewuleixing',
          prop: 'type',
          type: 'dictionary',
          key: 'BUSINESS_TYPE',
          width: 150
        },
        {
          label: 'guizexiangqing',
          type: 'slot',
          prop: 'info'
        },
        {
          label: 'shifouqiyong',
          prop: 'isEnabled',
          type: 'bool',
          iln18: ['shi', 'fou'],
          width: 80
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 150
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 150
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      console.log(this.yt.get(1));
      this.yt.get(1);
      this.utils.event_hub.$on('QUALITY_MANAGEMENT_METHOD_REFRESH', () => {
        this.yt.get(1);
      });
    }, 300);
  },
  methods: {
    move(type) {
      console.log('选中', this.currentRow);
      if (type == 1) {
        //上移
        let index = 0;
        for (let i = 0; i < this.labelRuleDetailsVOList.length; i++) {
          if (this.labelRuleDetailsVOList[i].checked == true) {
            index = i;
            break;
          }
        }
        console.log('索引', index);
        if (index > 0) {
          let tempsArr = this.utils.copy(this.labelRuleDetailsVOList);
          let temp = tempsArr[index - 1];
          // temp.checked = true
          tempsArr[index - 1] = tempsArr[index];
          tempsArr[index] = temp;
          this.labelRuleDetailsVOList = tempsArr;
          console.log('交换位置后', this.labelRuleDetailsVOList);
          this.setCurrent(this.labelRuleDetailsVOList[index - 1]);
        }
      }
      if (type == 2) {
        //下移
        let index = 0;
        for (let i = 0; i < this.labelRuleDetailsVOList.length; i++) {
          if (this.labelRuleDetailsVOList[i].checked == true) {
            index = i;
            break;
          }
        }
        console.log('索引', index);
        if (index < this.labelRuleDetailsVOList.length - 1) {
          let tempsArr = this.utils.copy(this.labelRuleDetailsVOList);
          let temp = tempsArr[index + 1];
          tempsArr[index + 1] = tempsArr[index];
          tempsArr[index] = temp;
          this.labelRuleDetailsVOList = tempsArr;
          console.log('交换位置后', this.labelRuleDetailsVOList);
          this.setCurrent(this.labelRuleDetailsVOList[index + 1]);
        }
      }
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    addRow(rows) {
      console.log('增加一行', rows);
      rows.push({
        ruleType: '',
        initialValue: '',
        checked: false
      });
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      console.log('选中', this.currentRow);

      //其他的取消勾选
      for (let i = 0; i < this.labelRuleDetailsVOList.length; i++) {
        this.labelRuleDetailsVOList[i].checked = false;
      }
      this.currentRow.checked = true;
      this.moveButton = false;
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    setDefaultValue() {
      this.yt.editObj.isEnabled = 1;
      this.labelRuleDetailsVOList = [];
      this.moveButton = true;
    },
    setDefaultValue2(row) {
      this.moveButton = true;
      this.currentRow = null;
      let tmp = this.utils.copy(row.labelRuleDetailsVOList);
      console.log('编辑预处理', tmp);
      for (let i = 0; i < tmp.length; i++) {
        if (tmp[i].ruleType == '2') {
          tmp[i].input2 = tmp[i].initialValue;
        }
        if (tmp[i].ruleType == '3') {
          tmp[i].input3 = tmp[i].initialValue;
        }
        if (tmp[i].ruleType == '4') {
          tmp[i].input4 = tmp[i].initialValue;
        }
        if (tmp[i].ruleType == '5') {
          tmp[i].input5 = tmp[i].initialValue;
        }
        if (tmp[i].ruleType == '6') {
          tmp[i].input6 = tmp[i].initialValue;
        }
        if (tmp[i].ruleType == '8') {
          tmp[i].input8 = tmp[i].initialValue;
        }
      }

      this.labelRuleDetailsVOList = tmp;
    },
    getProcedureCode() {
      this.http.get('/web/label/rule/page').then(res => {
        if (this.yt.editObj.action == 'xinzeng') {
        }
      });
    },
    beforeNewAdd(params) {
      console.log('提交预处理', params);

      for (let i = 0; i < this.labelRuleDetailsVOList.length; i++) {
        if (this.labelRuleDetailsVOList[i].ruleType == '2') {
          this.labelRuleDetailsVOList[i].initialValue = this.labelRuleDetailsVOList[i].input2;
        }
        if (this.labelRuleDetailsVOList[i].ruleType == '3') {
          this.labelRuleDetailsVOList[i].initialValue = this.labelRuleDetailsVOList[i].input3;
        }
        if (this.labelRuleDetailsVOList[i].ruleType == '4') {
          this.labelRuleDetailsVOList[i].initialValue = this.labelRuleDetailsVOList[i].input4;
        }
        if (this.labelRuleDetailsVOList[i].ruleType == '5') {
          this.labelRuleDetailsVOList[i].initialValue = this.labelRuleDetailsVOList[i].input5;
        }
        if (this.labelRuleDetailsVOList[i].ruleType == '6') {
          this.labelRuleDetailsVOList[i].initialValue = this.labelRuleDetailsVOList[i].input6;
        }
        if (this.labelRuleDetailsVOList[i].ruleType == '8') {
          this.labelRuleDetailsVOList[i].initialValue = this.labelRuleDetailsVOList[i].input8;
        }
      }
      params.labelRuleDetailsVOList = this.labelRuleDetailsVOList;
      return params;
    }
  }
};
</script>
